import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";

import { trimmedStringParam } from "../../../lib/url-state";
import {
  AgentFilesPage,
  type AgentFilesSearch,
} from "../../../workspaces/agents/AgentFilesPage";
import { useLibraryProjectId } from "../../../workspaces/library/project";

export function parseAgentFilesSearch(search: Record<string, unknown>): AgentFilesSearch {
  return {
    view:
      search.view === "home" || search.view === "reports"
        ? search.view
        : undefined,
    path: trimmedStringParam(search.path),
    run: trimmedStringParam(search.run),
  };
}

export const Route = createFileRoute("/_console/p/$org/$project/library/agents/$agentId")({
  validateSearch: parseAgentFilesSearch,
  component: AgentFilesRoute,
});

/** One agent's files and their history, in the library beside the project's data. */
function AgentFilesRoute() {
  const { agentId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const projectId = useLibraryProjectId();
  const onStateChange = useCallback(
    (patch: AgentFilesSearch) =>
      void navigate({ search: (current) => ({ ...current, ...patch }), replace: true }),
    [navigate],
  );
  return (
    <AgentFilesPage
      projectId={projectId}
      agentId={agentId}
      state={search}
      onStateChange={onStateChange}
    />
  );
}
